import * as React from "react";
import { FunctionComponent } from "react";
import {
  BaseModuleProps,
  ButtonModuleSettings,
  StoreState,
  ColorScheme,
} from "../../types";
import Button from "../Button";
import { connect } from "react-redux";
import { resolveButtonLink } from "../../utils/utils";
import { getActiveSite } from "../../selectors/sites";

type Props = Pick<
  BaseModuleProps<ButtonModuleSettings>,
  "translatedModule" | "isPreview"
> & {
  scheme: ColorScheme;
  className?: string;
};

interface StateProps {
  anchorAttrs: React.AnchorHTMLAttributes<HTMLAnchorElement>;
}

const ButtonModule: FunctionComponent<Props & StateProps> = ({
  translatedModule: { settings, translation },
  isPreview,
  anchorAttrs,
  scheme,
  className,
}) => {
  if (!translation.exists) return null;

  return (
    <Button
      className={className}
      scheme={scheme}
      isPreview={isPreview}
      {...settings}
      anchorAttrs={anchorAttrs}
    >
      {translation.settings.title}
    </Button>
  );
};

const mapStateToProps = (
  { pages, sites }: StoreState,
  { translatedModule, isPreview }: Props
): StateProps => {
  const site = getActiveSite(sites);
  const anchorAttrs = resolveButtonLink({
    pages,
    isPreview,
    site,
    translatedModule,
  });

  return {
    anchorAttrs,
  };
};

export default connect(mapStateToProps)(ButtonModule);
